import { Block } from '@xprog/prensa'
import { WidgetTypes, WIDGET_TYPES } from 'hooks/useGCJAnalytics'
import useOnScreen from 'hooks/useOnScreen'
import React, { useEffect, useRef } from 'react'

export type WhatsAppBannerProps = {
  children?: any
  className?: string
  customProps?: {
    className?: string
  },
  telNumber?: string,
  handleSendClickEvent: (type: WidgetTypes) => void;
  handleSendViewEvent: (type: WidgetTypes) => void;
}

const WhatsAppBanner: React.FC<WhatsAppBannerProps> = (props) => {
  const slug = process.env.NEXT_PUBLIC_WEBAPP_CLIENT_SLUG || 'opopular'

  const className = props.customProps?.className
  const baseClassName = `WhatsAppBanner ${props?.className || ''} ${className}`
  const isDesktop = props?.customProps?.className?.includes('desktop')
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    if(isVisible) {
      props.handleSendViewEvent(WIDGET_TYPES.WHATSAPP);
    }
  }, [isVisible]);

  if (isDesktop) return <></>
  return (
    <a id='whatsapp-pop' href={`https://api.whatsapp.com/send?phone=${props.telNumber}`} onClick={() => props.handleSendClickEvent(WIDGET_TYPES.WHATSAPP)} rel='noreferrer' target='_blank'>
      <Block
        ref={ref}
        className={baseClassName}
        css={{
          align: ['row', 'center', 'middle'],
          'img': {
            width: 'calc(100% - $4)'
          },
          mb: '$6'
        }}
      >
        <img src={`/assets/${slug}/banners/BannerWhatsApp.svg`} alt='WhatsApp' />
      </Block>
    </a>  
  )
}

export default WhatsAppBanner
